import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import {
  getAllSelectedItemsByApp,
  removeItemFromSubscription,
} from './AppService';
import AttachItem from './AttachItem';

import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Box,
  // Breadcrumbs,
  // Link,
} from '@mui/material';

import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { alpha, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const selectedItemList = ({ appId, subscriptionId }): JSX.Element => {
  const theme = useTheme();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [appIdToDelete, setAppIdToDelete] = useState(null);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);

  const { appid } = useParams();
  const { subscriptionid } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    console.log('useEffect subscriptionId:' + subscriptionId);
    listAppItems();

    return () => {};
  }, [appId, subscriptionId]);

  function listAppItems() {
    setLoading(true);
    getAllSelectedItemsByApp(appid)
      .then((response) => {
        setItems(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function selectItem(itemid) {
    console.log(itemid);
    navigate(`/admin/dashboard/subscription/${subscriptionid}/item/${itemid}`);
  }

  const handleDeleteConfirmation = (appId, itemId) => {
    setAppIdToDelete(appId);
    setItemIdToDelete(itemId);
    setOpenDialog(true);
  };

  const handleDeleteItem = () => {
    removeItem(appIdToDelete, itemIdToDelete);
    setOpenDialog(false);
  };

  function removeItem(appId, itemId) {
    removeItemFromSubscription(appId, itemId)
      .then(() => {
        listAppItems();
      })
      .catch((error) => {
        // Handle errors or exceptions
        if (error.response) {
          // The request was made and the server responded with a status code
          // Display an error message based on the response status
          console.error(
            'Request failed with status code:',
            error.response.status,
          );
          // Check if the error is due to a foreign key constraint violation
          if (
            error.response.status === 400 &&
            typeof error.response.data === 'string' &&
            error.response.data.includes('foreign key constraint')
          ) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete the item because it is referenced by other records.',
            );
          }
          if (error.response.status === 401) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete or update a parent row: a foreign key constraint fails.',
            );
          } else {
            // Display a generic error message for other types of errors
            notify(
              'An error occurred while deleting the item. Please try again later.',
            );
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error(
            'Request made but no response received:',
            error.request,
          );
        } else {
          // Something happened in setting up the request that triggered an error
          console.error('Error setting up the request:', error.message);
        }
      });
  }

  return (
    <Container>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={4}
      >
        <Typography variant="h4">Selected Content</Typography>
        {/* <br />
        <Typography variant="h6">
          App Code must be set against Item to be selectable
        </Typography> */}
      </Box>
      {loading && <p>Loading...</p>}
      <AttachItem listAppItems={listAppItems} appId={appId} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: 'alternate.main' }}>
            <TableRow>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Item Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Version Number
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Build Number
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Status
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to remove this item?
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button onClick={handleDeleteItem} autoFocus>
                  Remove
                </Button>
              </DialogActions>
            </Dialog>
            {items.map((item, i) => (
              <TableRow
                key={i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                onClick={() => selectItem(item.id)}
              >
                <TableCell component="th" scope="row">
                  <ListItem sx={{ p: 0, m: 0 }}>
                    <ListItemAvatar>{/* <Avatar src={} /> */}</ListItemAvatar>
                    <ListItemText primary={item.id} secondary={item.id} />
                  </ListItem>
                </TableCell>
                <TableCell>
                  <Typography>{item.name}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant={'caption'}
                    fontWeight={700}
                    sx={{
                      bgcolor: alpha(theme.palette.success.light, 0.1),
                      color: theme.palette.success.dark,
                      paddingX: 1.5,
                      paddingY: 0.5,
                      borderRadius: 4,
                      display: 'inline',
                    }}
                  >
                    {item.versionNumber}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.buildNumber}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.status}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation(); // Stop the click event from propagating
                        handleDeleteConfirmation(appId, item.id); // Show confirmation dialog before deleting
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default selectedItemList;
